// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/LoyaltyCircle/LoyaltyCircle.css
// module id = 461
// module chunks = 0